import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=6e549a86&scoped=true&"
import script from "./approval.vue?vue&type=script&lang=ts&"
export * from "./approval.vue?vue&type=script&lang=ts&"
import style0 from "./approval.vue?vue&type=style&index=0&id=6e549a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e549a86",
  null
  
)

export default component.exports